import { Link } from "react-router-dom";
import { useCustomerRoles } from "../CustomerRolesContext";

/**
 * Route gate: render children only if the caller has at least one required role.
 */
export default function RequireCustomerRole({ anyOf, children, title = "Access denied" }) {
  const { rolesReady, hasAnyRole } = useCustomerRoles();

  if (!rolesReady) {
    return <p style={{ padding: 24, color: "#6b7280" }}>Loading permissions…</p>;
  }

  if (!hasAnyRole(anyOf)) {
    const needed = (anyOf || []).join(" or ");
    return (
      <div style={{ padding: 24, maxWidth: 520 }}>
        <h2 style={{ marginTop: 0 }}>{title}</h2>
        <p style={{ color: "#4b5563", lineHeight: 1.5 }}>
          Your account does not have permission for this page
          {needed ? ` (requires ${needed})` : ""}. Ask an IT Admin for your
          organization to assign the appropriate role.
        </p>
        <Link to="/" style={{ color: "#2563eb" }}>
          Back to Dashboard
        </Link>
      </div>
    );
  }

  return children;
}
